export default __webpack_public_path__ + "static/media/main.d152b918.png";